import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "backdrop"]

  toggle(event) {
    event.preventDefault()
    if (this.drawerTarget.hasAttribute("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.drawerTarget.removeAttribute("hidden")
    if (this.hasBackdropTarget) this.backdropTarget.removeAttribute("hidden")
    document.body.classList.add("site-nav-open")
  }

  close(event) {
    if (event) event.preventDefault()
    this.drawerTarget.setAttribute("hidden", "hidden")
    if (this.hasBackdropTarget) this.backdropTarget.setAttribute("hidden", "hidden")
    document.body.classList.remove("site-nav-open")
  }
}
